import { cn } from '../lib/utils';

const MEDAL_DATA = {
  1: { emoji: '🥇', shimmerClass: 'shimmer-gold', color: '#fbbf24', bg: 'rgba(251,191,36,0.12)', border: 'rgba(251,191,36,0.3)' },
  2: { emoji: '🥈', shimmerClass: 'shimmer-silver', color: '#94a3b8', bg: 'rgba(148,163,184,0.12)', border: 'rgba(148,163,184,0.3)' },
  3: { emoji: '🥉', shimmerClass: 'shimmer-bronze', color: '#b87333', bg: 'rgba(184,115,51,0.12)', border: 'rgba(184,115,51,0.3)' },
};

export default function RankBadge({ rank, size = 'md' }) {
  const medal = MEDAL_DATA[rank];
  const sizeClass = size === 'lg' ? 'w-10 h-10 text-lg' : size === 'sm' ? 'w-6 h-6 text-xs' : 'w-8 h-8 text-sm';

  if (medal) {
    return (
      <div
        className={cn('relative flex items-center justify-center rounded-full font-bold overflow-hidden', sizeClass)}
        style={{ background: medal.bg, border: `1px solid ${medal.border}` }}
      >
        <span className="relative z-10">{medal.emoji}</span>
        {/* shimmer overlay */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: `linear-gradient(90deg, transparent, ${medal.color}33, transparent)`,
            backgroundSize: '200% 100%',
            animation: 'shimmer 2s linear infinite',
          }}
        />
      </div>
    );
  }

  return (
    <div
      className={cn('flex items-center justify-center rounded-full font-bold', sizeClass)}
      style={{
        background: 'rgba(255,255,255,0.06)',
        border: '1px solid rgba(255,255,255,0.1)',
        color: '#94a3b8',
        fontSize: '0.75rem',
      }}
    >
      {rank}
    </div>
  );
}
